import { storeToRefs } from "pinia";
import { useProductStore } from "@/stores/modules/product";

export const useProduct = () => {
  const productStore = useProductStore();
  const {
    product,
    products,
    productsTicketRequire,
    productsRequired,
    productsTicketNoRequire,
    purchaseProductsResume,
    productsPurchase,
    productDeletedId,
    totalProductPrice,
    totalProductTaxes,
    formattedTickets,
    groupedProductsByGroup,
    error
  } = storeToRefs(productStore);

  const getProductsByTicket = async params => {
    await productStore.getProductsByTicket(params);
  };
  const clasifyProductsByTicketRequire = () => {
    productStore.clasifyProductsByTicketRequire();
  };
  const maxCantArray = product => {
    const cantArray = [];
    for (let i = 1; i <= product.max_by_ticket; i++) {
      cantArray.push({ value: i });
    }

    return cantArray;
  };
  const resetProductsList = () => {
    productStore.resetProductsList();
  };
  // Añadir producto a la compra
  const setProductsPurchase = (product, ticketType, ticketId, ticketTitle) => {
    const productCopy = {
      id: product.id,
      name: product.name,
      quantity: product.cant || 1,
      ticket_id: ticketId || undefined,
      ticket_name: ticketTitle || "",
      price: parseFloat(product.price) * (product.cant || 1),
      original_price: parseFloat(product.price),
      commision: parseFloat(product.commision) || 0,
      description: product.description,
      ticket_type: ticketType,
      max_by_ticket: product.max_by_ticket,
      additional_data: {},
      ticket_required: product.ticket_required,
      size: product.size,
      color: product.color
      // TODO: Additional_data
    };

    productStore.setProductsPurchase(productCopy);
  };
  const productPurchaseInit = () => {
    if (productsRequired.value.length > 0) {
      for (const require of productsRequired.value) {
        setProductsPurchase(require.product);
      }
    }
  };
  const createProductPurchaseData = product => {
    return productStore.createProductPurchaseData(product);
  };
  const addProductsToTickets = () => {
    productStore.addProductsToTickets();
  };
  const clasifyComplementaryItems = () => {
    productStore.clasifyComplementaryItems();
  };

  // Actualización de la compra
  const updateProductPurchase = id => {
    const individualProd = productsPurchase.value.find(prod => prod.id === id);

    if (individualProd) {
      const quantity = 1;
      individualProd.quantity += quantity;
    }

    individualProd.price =
      individualProd.original_price * individualProd.quantity;
  };

  const updateProductRequiredPurchase = (id, quantity, ticketId) => {
    let individualProd = {};
    individualProd = productsPurchase.value.find(
      prod => prod.id === id && prod.ticket_id === ticketId
    );
    if (individualProd) {
      individualProd.quantity = quantity;
    }

    individualProd.price =
      individualProd.original_price * individualProd.quantity;
  };

  const resetProductPurchase = () => {
    productsPurchase.value = [];
  };
  // Eliminar producto de la compra
  const deleteProductPurchase = (id, ticket) => {
    productStore.deleteProductPurchase(id, ticket);
  };

  return {
    // Properties
    product,
    products,
    productsTicketRequire,
    productsRequired,
    productsTicketNoRequire,
    productsPurchase,
    formattedTickets,
    productDeletedId,
    error,
    // Getters
    totalProductPrice,
    totalProductTaxes,
    purchaseProductsResume,
    groupedProductsByGroup,
    // Methods
    getProductsByTicket,
    clasifyProductsByTicketRequire,
    maxCantArray,
    setProductsPurchase,
    productPurchaseInit,
    createProductPurchaseData,
    addProductsToTickets,
    resetProductsList,
    resetProductPurchase,
    deleteProductPurchase,
    updateProductPurchase,
    updateProductRequiredPurchase,
    clasifyComplementaryItems
  };
};
